$(document).ready(function() {
  $("#search-again").click(function() {
    $('#lead-form').removeClass('d-none');
    $('#lead-form-mini').removeClass('d-none');
    $('#results').addClass('d-none');
  });
});

$(document).ready(function() {
  $("#try-again").click(function() {
    $('#lead-form').removeClass('d-none');
    $('#lead-form-mini').removeClass('d-none');
    $('#error').addClass('d-none');
  });
});
